import { render, staticRenderFns } from "./RelatedClinicItem.vue?vue&type=template&id=38040e5a&scoped=true&"
import script from "./RelatedClinicItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RelatedClinicItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RelatedClinicItem.vue?vue&type=style&index=0&id=38040e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38040e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38040e5a')) {
      api.createRecord('38040e5a', component.options)
    } else {
      api.reload('38040e5a', component.options)
    }
    module.hot.accept("./RelatedClinicItem.vue?vue&type=template&id=38040e5a&scoped=true&", function () {
      api.rerender('38040e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRelatedClinics/components/RelatedClinicItem.vue"
export default component.exports